import { useTranslation } from "react-i18next";
import PageBanner from "../../../Shared/PageBanner";
import bannerBg from "../../../assets/img/Banner/Top-Image8.jpg";
import TopicContentDetails from "./TopicContentDetails";
import { useNavigate } from "react-router-dom";
import { useFetchGeneralSettingQuery } from "../../../app/feature/API/Helpers";
import { useEffect } from "react";

const TopicDetails = () => {
  const {i18n} = useTranslation()
  const navigate = useNavigate();
  const { data: GeneralSetting } = useFetchGeneralSettingQuery();
  const knowledge_base_page_show = GeneralSetting?.map((e)=>e?.knowledge_base_page_show)

  useEffect(() => {

    if (Number(knowledge_base_page_show)===0) {
      navigate("/");
    }
  }, [knowledge_base_page_show, navigate]);
  return (
    <div>
      <PageBanner title={`${i18n.language==='en'?"Topics":"المواضيع"}`} bannerBg={bannerBg} currentPage={`${i18n.language==='en'?"Topics":"المواضيع"}`} />
      <TopicContentDetails/>
    </div>
  );
};

export default TopicDetails;
